import {
  CButton,
  CCol,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react-pro";
import { FC } from "react";
import { assigneeAdapter } from "../../../../types";
import { MultiSelectProps } from "../../../../../hooks/useInputMultiSelect";

interface PssAssigneeDeleteModalProps {
  state: {
    visible: boolean;
    name: MultiSelectProps<string>;
    id: string;
  };
  controller: {
    onClose: () => void;
    onDelete: (item: assigneeAdapter) => void;
  };
}

export const DeleteAssigneeModal: FC<PssAssigneeDeleteModalProps> = ({
  state,
  controller,
}) => {
  return (
    <CModal visible={state.visible} onClose={controller.onClose}>
      <CModalHeader className="card-title">
        <CModalTitle>
          <strong>Delete Confirmation</strong>
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CRow>
          <CCol>
            Are you sure you want to permanently delete? This action cannot be
            undone.
          </CCol>
        </CRow>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={controller.onClose}>
          Cancel
        </CButton>
        <CButton
          style={{
            backgroundColor: "#2D3569",
          }}
          onClick={() => controller.onDelete({ id: state.id })}
        >
          Confirm
        </CButton>
      </CModalFooter>
    </CModal>
  );
};
